import React, { PropTypes, Component } from 'react'
import NextIcon from './icons/next.svg'

class NextButton extends Component {
  render () {
    return (
      <button className={this.props.className} type='button' onClick={this.props.handleNext}>
        <img alt='Next' src={NextIcon} />
      </button>
    )
  }
}

NextButton.propTypes = {
  handleNext: PropTypes.func,
  className: PropTypes.string
}

export default NextButton



/** WEBPACK FOOTER **
 ** ./src/components/NextButton.js
 **/